import axios from '@/axios';

// URL and endpoint constants
const INDEX_URL = '/articles';

export default {
  index(succ, articleIndex) {
    axios.get(`${INDEX_URL}/${articleIndex}`)
      .then((response) => { succ(response); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/article.js